import {Endpoint} from '../endpoint';
import {SystemCalendarId, SystemCalendarResponse} from "@business/entities/system_calendar";

export function fetchSystemCalendars() {
    return Endpoint.get<SystemCalendarResponse[]>(`@gc/system-calendars`);
}

export function createSystemCalendar(title: string) {
    return Endpoint.post<SystemCalendarResponse>(`@gc/system-calendars`, {data: {title}});
}

export function updateSystemCalendar(id: SystemCalendarId, title: string) {
    return Endpoint.patch<SystemCalendarResponse>(`@gc/system-calendars/${id}`, {data: {title}});
}

export function deleteSystemCalendar(calendarId: SystemCalendarId) {
    return Endpoint.delete<void>(`@gc/system-calendars/${calendarId}`);
}
